export default __webpack_public_path__ + "static/media/photo_gallery_10.ac7d47f7.png";